module.exports = __webpack_public_path__ + "img/pic_404.2f8ac22e.png";